import { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import { Calendar, Clock } from 'lucide-react';
import 'react-datepicker/dist/react-datepicker.css';

interface DateTimePickerProps {
  selected: Date | null;
  onChange: (date: Date | null) => void;
  minDate?: Date;
  showTimeSelect?: boolean;
  dateFormat?: string;
  placeholderText?: string;
  className?: string;
}

// Custom input component to match our styling
const CustomInput = forwardRef<HTMLButtonElement, { value?: string; onClick?: () => void; placeholder?: string }>(
  ({ value, onClick, placeholder }, ref) => (
    <button
      type="button"
      onClick={onClick}
      ref={ref}
      className="input w-full h-[52px] text-left flex items-center gap-3"
    >
      <Calendar className="w-5 h-5 text-white/40 flex-shrink-0" />
      <span className={value ? 'text-white' : 'text-white/30'}>
        {value || placeholder || 'Select date & time'}
      </span>
      <Clock className="w-4 h-4 text-white/40 ml-auto flex-shrink-0" />
    </button>
  )
);

CustomInput.displayName = 'CustomInput';

export default function DateTimePicker({
  selected,
  onChange,
  minDate = new Date(),
  showTimeSelect = true,
  dateFormat = "MM/dd/yyyy, h:mm aa",
  placeholderText = "Select date & time",
  className = "",
}: DateTimePickerProps) {
  return (
    <div className={`datetime-picker-wrapper ${className}`}>
      <DatePicker
        selected={selected}
        onChange={onChange}
        showTimeSelect={showTimeSelect}
        timeFormat="h:mm aa"
        timeIntervals={15}
        dateFormat={dateFormat}
        minDate={minDate}
        customInput={<CustomInput placeholder={placeholderText} />}
        calendarClassName="dark-calendar"
        popperClassName="dark-calendar-popper"
        wrapperClassName="w-full"
      />
    </div>
  );
}

